import React from "react";
import { Link, useNavigate } from "react-router-dom";

const DashboardCard = ({ title, value, link, icon,onClick  }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (link) {
      navigate(link)
      
    }
  };

  return (
    <div 
      onClick={handleClick}
      className="group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:border-blue-200 cursor-pointer transform hover:scale-105"
    >
      {/* Background gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      
      {/* Content container */}
      <div className="relative z-10 flex flex-col h-full">
        {/* Header with icon */}
        <div className="flex items-center justify-between mb-4">
          <div className="p-3 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors duration-300">
            <img
              src={icon}
              alt={title}
              className="w-6 h-6 object-contain"
            />
          </div>
          <div className="w-2 h-2 bg-blue-400 rounded-full opacity-60"></div>
        </div>
        
        {/* Title */}
        <h6 className="text-sm font-medium text-gray-600 mb-2 uppercase tracking-wide">
          {title}
        </h6>
        
        {/* Value */}
        <h2 className="text-3xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors duration-300">
          {value}
        </h2>
        
        {/* Bottom indicator */}
        <div className="mt-auto flex items-center text-sm text-gray-500 group-hover:text-blue-600 transition-colors duration-300">
          <span className="mr-2">View details</span>
          <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
};


export default DashboardCard;